@if (paginatedObject; as data) {
	@if (entity(); as primary) {
		<section tuiTableContainer>
			<header tuiTableHeader class="justify-between items-center">
				<span class="flex items-center">
					<ng-content />
				</span>

				@if (allowExport()) {
					<mar-export-button
						size="s"
						appearance="outline"
						[disabled]="!data.items.length"
						(click)="onExport()"
					/>
				}
			</header>

			<div #scroller tuiTableWrapper>
				<table
					tuiTable
					[columns]="columnKeys"
					[direction]="(direction$ | async) || 1"
					[tuiSortBy]="sorter$ | async"
					(directionChange)="direction$.next($event)"
					(tuiSortChange)="onSortChange($any($event))"
				>
					<thead>
						<tr tuiThGroup>
							<th
								tuiTh
								size="l"
								*tuiHead="primary"
								[tuiSortable]="false"
							>
								{{
									'customer-product.top-count.' + primary
										| transloco
								}}
							</th>

							<th
								tuiTh
								size="s"
								*tuiHead="'revenueInCents'"
								[tuiSortable]="false"
							>
								{{
									'customer-product.top-count.revenue'
										| transloco
								}}
							</th>

							<th
								tuiTh
								size="xs"
								*tuiHead="'count80'"
								[tuiSortable]="false"
							>
								{{ translation() + '.count-of-80' | transloco }}
							</th>

							<th
								tuiTh
								size="xs"
								*tuiHead="'count20'"
								[tuiSortable]="false"
							>
								{{ translation() + '.count-of-20' | transloco }}
							</th>

							<th
								tuiTh
								size="xs"
								*tuiHead="'percent80'"
								[tuiSortable]="false"
							>
								{{ translation() + '.%-of-80' | transloco }}
							</th>

							<th
								tuiTh
								size="xs"
								*tuiHead="'transactionCount'"
								[tuiSortable]="false"
							>
								{{
									'customer-product.top-count.transactions'
										| transloco
								}}
							</th>

							<th
								tuiTh
								size="m"
								*tuiHead="'transactionAvgInCents'"
								[tuiSortable]="false"
							>
								{{
									'customer-product.top-count.average-transaction'
										| transloco
								}}
							</th>

							<th
								tuiTh
								size="xs"
								*tuiHead="'marginPercent80'"
								[tuiSortable]="false"
							>
								@if ('direct' | isCostType) {
									{{ translation() + '.cm%-80' | transloco }}
								} @else {
									{{ translation() + '.mm%-80' | transloco }}
								}
							</th>

							<th
								tuiTh
								size="xs"
								*tuiHead="'marginPercent20'"
								[tuiSortable]="false"
							>
								@if ('direct' | isCostType) {
									{{ translation() + '.cm%-20' | transloco }}
								} @else {
									{{ translation() + '.mm%-20' | transloco }}
								}
							</th>

							<th
								tuiTh
								size="xs"
								*tuiHead="'marginPercent'"
								[tuiSortable]="false"
							>
								@if ('direct' | isCostType) {
									{{
										translation() + '.cm%-total' | transloco
									}}
								} @else {
									{{
										translation() + '.mm%-total' | transloco
									}}
								}
							</th>
						</tr>
					</thead>
					@let sortedData = data.items | tuiTableSort;
					<tbody tuiTbody [data]="sortedData">
						@if (loading$ | async) {
							<!-- 11 for the additional footer at the bottom of the table -->
							@for (item of [].constructor(10); track $index) {
								<tr>
									@for (
										item of [].constructor(10);
										track $index
									) {
										<td>
											<p
												class="m-0"
												[tuiSkeleton]="2"
											></p>
										</td>
									}
								</tr>
							}
						} @else if (data.items.length) {
							@for (item of data.items; track item.id) {
								<tr tuiTr>
									<td
										*tuiCell="primary"
										tuiTd
										[innerText]="item.data[primary]"
									></td>

									<td
										*tuiCell="'revenueInCents'"
										tuiTd
										[innerText]="
											item.data.revenueInCents
												| centsToDollars
										"
									></td>

									<td
										*tuiCell="'count80'"
										tuiTd
										[innerText]="item.data.count80"
									></td>

									<td
										*tuiCell="'count20'"
										tuiTd
										[innerText]="item.data.count20"
									></td>

									<td
										*tuiCell="'percent80'"
										tuiTd
										[innerText]="
											item.data.percent80 | percentToValue
										"
									></td>

									<td
										*tuiCell="'transactionCount'"
										tuiTd
										[innerText]="item.data.transactionCount"
									></td>

									<td
										*tuiCell="'transactionAvgInCents'"
										tuiTd
										[innerText]="
											item.data.transactionAvgInCents
												| centsToDollars
										"
									></td>

									<td
										*tuiCell="'marginPercent80'"
										tuiTd
										[innerText]="
											item.data.marginPercent80
												| percentToValue
										"
									></td>

									<td
										*tuiCell="'marginPercent20'"
										tuiTd
										[innerText]="
											item.data.marginPercent20
												| percentToValue
										"
									></td>

									<td
										*tuiCell="'marginPercent'"
										tuiTd
										[innerText]="
											item.data.marginPercent
												| percentToValue
										"
									></td>
								</tr>
							}

							<!-- as long as the paginated object has more, we should be showing the loading -->
							@if (paginatedObject.hasMore) {
								<tr>
									<td [colSpan]="10">
										<div tuiTableInfiniteLoader>
											<tui-loader size="s" />
											{{
												'generic.loading-more'
													| transloco
											}}
										</div>
									</td>
								</tr>
							}
						} @else {
							<tr>
								<td [colSpan]="11">
									<div tuiTablePlaceholder>
										<h2 class="max-w-md">
											{{
												'customer-product.' +
													entity() +
													'.breakdown.table-placeholder'
													| transloco
											}}
										</h2>
									</div>
								</td>
							</tr>
						}
					</tbody>
				</table>
			</div>
		</section>

		<small class="my-1 mx-4 italic block text-inherit">
			{{ 'generic.disclaimer.rounded' | transloco }}
		</small>
	}
}
